import React from 'react';

type AciklamaTurButonlariProps = {
    value: string;
    onChange: (deger: string) => void;
    style?: React.CSSProperties;
};

/**
 * Ödeme açıklaması alanının yanına eklenen "Peşinat" / "Kapora" hızlı işaretleme butonları.
 * Tıklanınca açıklama metnini o kelimeyle değiştirir; kullanıcı sonrasında yine de
 * serbestçe düzenleyebilir (bkz. metin girişi). Aktif eşleşme, mevcut açıklamanın
 * o kelimeyle (büyük/küçük harf duyarsız) başlamasına göre vurgulanır.
 */
const AciklamaTurButonlari: React.FC<AciklamaTurButonlariProps> = ({ value, onChange, style }) => {
    const secenekler: Array<{ etiket: string; deger: string }> = [
        { etiket: 'Peşinat', deger: 'Peşinat' },
        { etiket: 'Kapora', deger: 'Kapora' },
    ];

    const aktifMi = (deger: string) => (value || '').trim().toLowerCase().startsWith(deger.toLowerCase());

    return (
        <div style={{ display: 'flex', gap: 4, flexShrink: 0, ...style }}>
            {secenekler.map(s => {
                const aktif = aktifMi(s.deger);
                return (
                    <button
                        key={s.deger}
                        type="button"
                        title={`Açıklamayı "${s.deger}" olarak işaretle`}
                        onClick={() => onChange(s.deger)}
                        style={{
                            padding: '3px 8px',
                            fontSize: 11,
                            fontWeight: 600,
                            borderRadius: 20,
                            border: aktif ? '1px solid #cd6906' : '1px solid #e2e8f0',
                            background: aktif ? '#fef3c7' : '#fff',
                            color: aktif ? '#92400e' : '#64748b',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {s.etiket}
                    </button>
                );
            })}
        </div>
    );
};

export default AciklamaTurButonlari;
